import { motion } from 'framer-motion'
import AssetCard from './AssetCard'
import logoOnly from '../../assets/logo-only.png'
import logoTransparent from '../../assets/logo-transparent.png'
import logoWithName from '../../assets/logo-with-name.png'

const BrandAssets = () => {
  const assets = [
    {
      title: 'Logo Only (Square)',
      imageUrl: logoOnly,
      downloadUrl: logoOnly,
      formats: ['PNG'],
    },
    {
      title: 'Transparent Logo Only (Square)',
      imageUrl: logoTransparent,
      downloadUrl: logoTransparent,
      formats: ['PNG'],
    },
    {
      title: 'Logo + Name (Rectangle)',
      imageUrl: logoWithName,
      downloadUrl: logoWithName,
      formats: ['PNG'],
    },
    {
      title: 'Cura Circle Logo',
      imageUrl: 'https://yulrybffcqnndtdmlbum.supabase.co/storage/v1/object/public/Cura%20Email/CuraCircle.png',
      downloadUrl: 'https://yulrybffcqnndtdmlbum.supabase.co/storage/v1/object/public/Cura%20Email/CuraCircle.png',
      formats: ['PNG'],
    },
    {
      title: 'Cura Logo (Transparent)',
      imageUrl: 'https://yulrybffcqnndtdmlbum.supabase.co/storage/v1/object/public/Cura%20Email/LogoOnly.png',
      downloadUrl: 'https://yulrybffcqnndtdmlbum.supabase.co/storage/v1/object/public/Cura%20Email/LogoOnly.png',
      formats: ['PNG'],
    },
    {
      title: 'Cura Logo + Text (Black)',
      imageUrl: 'https://yulrybffcqnndtdmlbum.supabase.co/storage/v1/object/public/Cura%20Email/4c3397bb70e3c3d84e4233363083cd66.png',
      downloadUrl: 'https://yulrybffcqnndtdmlbum.supabase.co/storage/v1/object/public/Cura%20Email/4c3397bb70e3c3d84e4233363083cd66.png',
      formats: ['PNG'],
      isTransparent: true,
    },
  ]

  return (
    <motion.section
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.8, delay: 0.8 }}
      className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8"
    >
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 1.0 }}
        className="text-center mb-12"
      >
        <h2 className="text-3xl font-light text-gray-800 mb-4">Brand Assets</h2>
        <p className="text-xl text-gray-700 max-w-2xl mx-auto">
          Download our official logos and brand assets for your media coverage and partnerships.
        </p>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {assets.map((asset, index) => (
          <AssetCard
            key={asset.title}
            {...asset}
            delay={1.2 + index * 0.1}
          />
        ))}
      </div>
    </motion.section>
  )
}

export default BrandAssets 